import { render, staticRenderFns } from "./admin-form-custom-fields.vue?vue&type=template&id=c8ebc43e&scoped=true&"
import script from "./admin-form-custom-fields.vue?vue&type=script&lang=js&"
export * from "./admin-form-custom-fields.vue?vue&type=script&lang=js&"
import style0 from "./admin-form-custom-fields.vue?vue&type=style&index=0&id=c8ebc43e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8ebc43e",
  null
  
)

export default component.exports